import {Route, Routes } from 'react-router-dom'
import NurseTabs, { tabConfig } from './Tabs'
import PageHeader from 'components/AppBar/PageHeader'
import { BasePathProvider } from 'components/Providers'
import { Box, Paper } from '@mui/material' 
import HealthConditions from './HealthConditions'
import Visits from './Visits'
import RedirectToFirstPermitted from 'components/RedirectToPermittedTab'
import Protected from 'components/Protected'
import HealthReportIndex from './HealthReport'
import VisitReportIndex from './VisitReport'
import PageNotFound from 'pages/PageNotFound'

export default function Health() {
const basePath = '/health'
  return (
    <BasePathProvider value={`${basePath}/`}>
        <Box sx={{ mb: 2}}>
            <PageHeader title={'Health'} />
        </Box>
        <Paper sx={{width: '100%', minHeight: '500px', p: 2, mb: 2}}>
            <NurseTabs />
            <Routes>
                <Route path="/">
                    <Route index element={<RedirectToFirstPermitted basePath={basePath} items={tabConfig} />} />
                    <Route path={"health-conditions/*"} element={<Protected permission="nurse.health"><HealthConditions /></Protected>} />
                    <Route path={"visits/*"} element={<Protected permission="nurse.visit"><Visits /></Protected>} />
                    <Route path={"health-report/*"} element={<Protected permission="nurse.health"><HealthReportIndex /></Protected>} />
                    <Route path={"visit-report/*"} element={<Protected permission="nurse.visit"><VisitReportIndex /></Protected>} />
                    <Route path="*" element={<PageNotFound />} />
                </Route>
            </Routes>
        </Paper>

    </BasePathProvider>
  )
}
